export default __webpack_public_path__ + "static/media/waffle_black.b8e5c779.svg";